<div class="_login-form-modal-content flex-column">
    <ng-container *ifNotLoggedIn>
        <div
             class="p-a-5 p-a-3-s b-b b-col-12 bg-col-w pos-relative flex flex-justify-center flex-middle _wishlist-sticky-bar">
            <span class="h4"
                  *iCms="'modalTitle' of content"></span>
            <!-- close icon -->
            <i class="icon-close cursor-pointer pos-absolute right-4 z-10 m-t-1"
               [attr.aria-label]="'Close' | translate"
               [style.font-size.px]="14"
               modalClose></i>
        </div>
        <div class="flex-grow overflow-auto">
            <p class="h2 p-t-10 p-t-4-s wrap"
               *iCms="'title' of content"></p>

            <p class="p2 col-11 p-t-2 m-b m-b--2-s wrap"
               *iCms="'description' of content"></p>

            <login-form-content class="w-12 wrap"></login-form-content>
        </div>
    </ng-container>

    <div class="wrap p-t-22"
         *ifLoggedIn>
        <div class="h3 p-t-10">{{"You're signed in" | translate}}</div>
        <p class="p2 p-t">{{'You can view recent orders in your account, add items to your wishlist
            and enjoy quicker
            checkout' | translate}}</p>

        <action class="button w-12 m-t-10"
                (click)="close()">{{'Continue shopping' | translate}}</action>
    </div>

</div>